import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getAssetPath } from "@/utils/assetUtils";
import { Progress } from "@/components/ui/progress";

interface SplashScreenProps {
  onComplete: () => void;
}

export const SplashScreen = ({ onComplete }: SplashScreenProps) => {
  const [isVisible, setIsVisible] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Progress bar animation over 5 seconds
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        const newProgress = prev + 2; // Increment by 2% every 100ms (5 seconds total)
        return newProgress >= 100 ? 100 : newProgress;
      });
    }, 100);

    // Animation completes after 5 seconds, wait 1 more second, then fade out (total 6 seconds)
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Allow fade out animation to complete before calling onComplete
      setTimeout(onComplete, 500);
    }, 6000);

    return () => {
      clearTimeout(timer);
      clearInterval(progressInterval);
    };
  }, [onComplete]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black"
        >
          <div className="relative flex flex-col items-center space-y-4">
            <img
              src={getAssetPath("disco_logo_v2.png")}
              alt="Disco Logo"
              className="h-32 md:h-40 lg:h-48 w-auto logo-fill-animation"
              onError={(e) => {
                // Fallback to regular logo if v2 fails
                e.currentTarget.src = getAssetPath("disco_logo.png");
              }}
            />
            <div className="w-full max-w-[16rem] md:max-w-[20rem] lg:max-w-[24rem] space-y-2">
              <Progress 
                value={progress} 
                className="h-2 bg-white/20 [&>div]:bg-white" 
              />
              <div className="text-center text-white text-sm font-medium">
                {progress}%
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};